import { useEffect, useState } from 'react'
import Event from '../Event'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import * as T from '../types'

const useGetMerchantSurchargeInfo = (self: any, merchantId: string) => {
  const [surchargeInfo, setSurchargeInfo] = useState<T.MerchantSurchargeInfo | null>(null)

  useEffect(() => {
    const handleResponse = (response: T.StatusAndResponse<T.MerchantSurchargeInfo>) => {
      if (response.status === 'success') {
        setSurchargeInfo(response.data)
      }
    }
    PubSub.pub(Event.GET_MERCHANT_SURCHARGE_INFO_REQUEST, merchantId)
    PubSub.sub(self, Event.GET_MERCHANT_SURCHARGE_INFO_RESPONSE, handleResponse)
    return () => {
      PubSub.unsub(self)
    }
  }, [self, merchantId])

  return surchargeInfo
}

export default useGetMerchantSurchargeInfo
